import { TagOption } from 'src/components/Tag';

export const DIRECTIONS: TagOption[] = [
  { label: 'Bottom to Top', value: 'bottom-to-up', icon: 'bottom-to-top' },
  { label: 'Top to Bottom', value: 'top-to-bottom', icon: 'top-to-bottom' },
  { label: 'Left to Right', value: 'left-right', icon: 'left-to-right' },
  { label: 'Right to Left', value: 'right-to-left', icon: 'right-to-left' },
];
